import styled from 'styled-components';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import COLORS from '../../common/styles/color-pallete';
export const Wrapper = styled.div<{ height?: number; width?: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  .MuiAvatar-colorDefault {
    color: ${COLORS.textGrey};
    background-color: ${COLORS.lightGrey};
    font-size: 18px;
    font-family: ${FONT_FAMILY.hellix.bold};
    line-height: 26px;
  }
  .MuiAvatar-root {
    width: ${({ width = 54 }) => width}px;
    height: ${({ height = 54 }) => height}px;
  }
`;
export const Img = styled.img`
  width: 16px;
  height: 16px;
`;
